import equal from 'fast-deep-equal';
import useProductListQueryFilters from '../hooks/useProductListQueryFilters';
import useProductListTotal from './useProductListTotal';
import useProductsList from './useProductsList';
import useProductListRootCategories from './useProductListRootCategories';

const useProductsListPage = ({ rootTree }: { rootTree: boolean }) => {
    const {
        rootCategoryId,
        skipLoadingWhileDefaultSortingLoading,
        skip,
        preorderSeasonId,
        includePreorderSeasonId,
        includeExcludedCategories,
        ...variables
    } = useProductListQueryFilters();

    const {
        items,
        filteredTotal,
        defaultValue,
        loading: productListLoading,
    } = useProductsList({
        skip: skip || skipLoadingWhileDefaultSortingLoading,
        preorderSeasonId,
        includePreorderSeasonId,
        includeExcludedCategories,
        ...variables,
    });

    const onlyFilterVariables = {
        ...variables,
        includeExcludedCategories,
        preorderSeasonId,
        includePreorderSeasonId,
        pageSize: undefined,
        page: undefined,
        sortField: undefined,
        sortDirection: undefined,
        isSalesRepresentative: undefined,
    };

    const { categoryId, store, language } = variables;

    const { categories, loading: categoryCountsLoading } =
        useProductListRootCategories({
            variables: onlyFilterVariables,
            skip,
            rootCategoryId,
            categoryId,
            rootTree,
        });

    const noAnyFiltersApplied = equal(onlyFilterVariables, {
        store,
        language,
        categoryId,
        preorderSeasonId,
        includePreorderSeasonId,
        includeExcludedCategories,
        states: [],
        filters: [],
        sortField: undefined,
        sortDirection: undefined,
        pageSize: undefined,
        page: undefined,
        minPrice: undefined,
        maxPrice: undefined,
        vehicleId: undefined,
        bicycleId: undefined,
        search: undefined,
        isSalesRepresentative: undefined,
        bestAvailability: undefined,
    });

    const { total, totalRequestLoading } = useProductListTotal({
        store,
        categoryId,
        language,
        preorderSeasonId,
        includePreorderSeasonId,
        includeExcludedCategories,
        skip: skip || noAnyFiltersApplied,
    });

    return {
        products: items,
        categories,
        total: noAnyFiltersApplied ? filteredTotal : total,
        filteredTotal,
        loading: productListLoading || skipLoadingWhileDefaultSortingLoading,
        categoryCountsLoading: categoryCountsLoading,
        totalLoading: noAnyFiltersApplied
            ? productListLoading && !!defaultValue
            : totalRequestLoading,
    };
};

export default useProductsListPage;
